export default __webpack_public_path__ + "f7b13da222d1dccb0e5687ac2dd205e1.svg";